import { Button, Icon } from './ui'

interface ErrorFallbackProps {
  error: unknown
  resetError: () => void
}

export function ErrorFallback({ error, resetError }: ErrorFallbackProps) {
  // Option to log the error to console for debugging if needed
  console.warn('CAUGHT ERROR:', error)

  return (
    <div className="min-h-[100dvh] w-full bg-[var(--color-background)] flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4">
           <Icon name="alert-triangle" size={32} className="text-[var(--color-error)]" />
        </div>
        <h2 className="text-2xl font-semibold text-[var(--color-text)] mb-2">Something went wrong</h2>
        <p className="text-[var(--color-text-muted)] mb-6">
          We apologize for the inconvenience. The error has been logged.
        </p>
        <div className="flex justify-center">
            <Button onClick={resetError}>Try Again</Button>
        </div>
      </div>
    </div>
  )
}
